import {
  DiiaLight as defaultTheme,
} from '#web-components/styles';
import { createMuiTheme } from '#web-components/exports/theme';
import { ThemeFlags } from '#web-components/types/theme';

export default () => {
  const theme = (APPLICATION_THEME as typeof defaultTheme) || defaultTheme;

  return createMuiTheme({
    typography: theme.typography,
    spacing: theme.spacing || 6,
    breakpoints: {
      values: {
        xs: 0,
        sm: 480, // Phone
        md: 992, // Tablet
        lg: 1548, // Laptop
        xl: 1842, // Desktop
      },
    },
    palette: {
      background: {
        default: theme.colors.layoutBackgroundOutside,
      },
      primary: {
        main: theme.colors.uIBase,
      },
      text: {
        primary: theme.colors.textMainPrimary,
      },
    },
    colors: theme.colors,
    flags: theme.flags as ThemeFlags,
    borders: theme.borders,
    shadow: theme.shadows,
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': [...theme.fonts.map((font) => ({
            fontFamily: font.fontFamily,
            fontStyle: font.fontStyle,
            fontWeight: font.fontWeight,
            src: `url('${process.env.PUBLIC_URL}/fonts/${font.fontName}') format('${font.fontFormat}')`,
          }))],
        },
      },
      MuiPaper: {
        elevation4: {
          boxShadow: 'none',
        },
      },
    },
  });
};
